import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { HttpException } from '../../exceptions/index';
import { ApiService } from '../../services/index';
import { useAppQuery } from '../use-app-query.hook';
import { DataRoomInvite } from './space.types';

/**
 * The only query in this module with no company scope: whoever follows an invitation link has no
 * session yet, and the token is what resolves the tenant on the server.
 *
 * Errors are handled by the caller rather than by a toast — every refusal is a code the page has
 * to render as a sentence, and a toast over a blank screen is exactly what this page exists to
 * avoid.
 */
export const useDataRoomInvite = (token: string | undefined) => {
  const { data: invite, error } = useAppQuery({
    defaultErrorHandling: false,
    enabled: Boolean(token),
    queryFn: () =>
      ApiService.get<DataRoomInvite>({
        endpoint: BackendRoute.DATA_ROOM_INVITES,
        routePath: [token ?? ''],
      }),
    queryKey: [QueryKey.DATA_ROOM_INVITE, token],
    retry: false,
  });

  return {
    error: error instanceof HttpException ? error : undefined,
    invite,
    isLoading: Boolean(token) && !invite && !error,
  };
};
